var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_8679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.5299 18.2338C18.9667 16.7969 17.061 12.5616 13.2734 8.77399C9.48573 4.98633 5.25042 3.08063 3.81357 4.51749C2.37671 5.95434 4.28242 10.1896 8.07007 13.9773C11.8577 17.765 16.093 19.6707 17.5299 18.2338Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5299 18.2338C18.9667 16.7969 17.061 12.5616 13.2734 8.77399C9.48573 4.98633 5.25042 3.08063 3.81357 4.51749C2.37671 5.95434 4.28242 10.1896 8.07007 13.9773C11.8577 17.765 16.093 19.6707 17.5299 18.2338Z",
    stroke: "#A461D8",
    strokeWidth: 1.33398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2734 13.9775C17.061 10.1898 18.9667 5.95452 17.5299 4.51766C16.093 3.08081 11.8577 4.98651 8.07007 8.77417C4.28242 12.5618 2.37671 16.7971 3.81357 18.234C5.25042 19.6708 9.48573 17.7651 13.2734 13.9775Z",
    stroke: "#A461D8",
    strokeWidth: 1.33398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6724 12.376C11.2249 12.376 11.6729 11.928 11.6729 11.3755C11.6729 10.8229 11.2249 10.375 10.6724 10.375C10.1198 10.375 9.67188 10.8229 9.67188 11.3755C9.67188 11.928 10.1198 12.376 10.6724 12.376Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_8679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3438,
    height: 21.3438,
    fill: "white",
    transform: "translate(0 0.703613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.10ac1657ca5dc8fd361cf013d3cafd50.svg";
export { ForwardRef as ReactComponent };